// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-block {\n  display: flex;\n  align-items: center;\n}\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.logo img {\n  max-width: 100px;\n  width: 100px;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
